"use client";
import Link from "next/link";
import federatedLogout from "@/app/utils/federated-logout";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Avatar,
} from "@nextui-org/react";

import { useRegisteredUser } from "@/context/RegisteredUserContext";

export default function Logout({ data }) {
  const { isRegistered, clearRegistration } = useRegisteredUser();
  return (
    <div className="flex items-center gap-2 cursor-pointer">
      <Dropdown>
        <DropdownTrigger>
          <div className="flex items-center gap-2">
            <Avatar
              className="bg-blue-800 text-white"
              size="sm"
              src={data.user?.image_1}
            />
            <span className="font-semibold text-blue-800 hover:text-blue-900">
              {data.user?.name}
            </span>
          </div>
        </DropdownTrigger>
        <DropdownMenu>
          {isRegistered ? (
            <>
              <DropdownItem as={Link} href={`/author/${data.user.id}`}>
                Ver Perfil
              </DropdownItem>
              <DropdownItem as={Link} href={`/author/${data.user.id}/edit`}>
                Editar Perfil
              </DropdownItem>
            </>
          ) : (
            <DropdownItem as={Link} href="/register">
              Registrarse
            </DropdownItem>
          )}
          <DropdownItem
            onPress={() => {
              clearRegistration();
              federatedLogout();
            }}
          >
            <div className="flex items-center gap-2 text-red-500 font-semibold">
              <span>Cerrar Sesión</span>
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
